// extracted by mini-css-extract-plugin
module.exports = {"statement":"statement_statement__1pFwC","content":"statement_content__3AL8Q"};